import { Dispatch, SetStateAction } from 'react';

import {
  QuestionnaireContainerStyled,
  QuestionnaireFormContainerStyled,
  SurveyResponseContainerStyled,
} from 'enrollment/features/Questionnaire/QuestionnaireStyled';
import {
  renderUnumApplicationQuestion,
  renderUnumQuestionDetails,
  isHiddenFollowUp,
  getUnumParentQuestion,
  getUnumHeightValue,
} from './utils';
import { UnumDetailFieldStyled } from '.';
import { UnumApplicantDto, UnumSectionDto } from 'enrollment/queries';
import { UnumApplicationSurveyResponsesDto } from '../types';

export interface UnumApplicationQuestionsProps {
  sections: UnumSectionDto[];
  questions: UnumApplicantDto[];
  responses: UnumApplicationSurveyResponsesDto;
  setResponses: Dispatch<SetStateAction<UnumApplicationSurveyResponsesDto>>;
}

export const UnumApplicationQuestions = ({
  sections,
  questions,
  responses,
  setResponses,
}: UnumApplicationQuestionsProps) => {
  const handleChange = (e: any) => {
    if (e.target.tagName !== 'INPUT') {
      return;
    }

    const name = e.target.name;
    let value = e.target.value;
    const parentQuestion = getUnumParentQuestion(questions, name);

    const followUpId = parentQuestion?.FollowUpQuestionID
      ? parentQuestion.FollowUpQuestionID
      : '';
    const indexValue = e.target.dataset[
      'questiontype'
    ] as keyof UnumApplicationSurveyResponsesDto;
    const detailFieldName = e.target.dataset['detailnum'];
    const isHeight = e.target.dataset['isheight'];

    if (isHeight) {
      value = getUnumHeightValue(
        value,
        String(responses[indexValue][name]),
        isHeight
      );
    }

    const newResponses = { ...responses };
    newResponses[indexValue] = {
      ...newResponses[indexValue],
      [name]: detailFieldName
        ? {
            ...(newResponses[indexValue][name] as {}),
            [detailFieldName]: value,
          }
        : value,
    };

    if (parentQuestion && value === parentQuestion.FollowUpQuestionTrigger) {
      newResponses[indexValue][followUpId] = '';
    }
    setResponses(newResponses);
  };

  return (
    <QuestionnaireContainerStyled className='mb-4'>
      <QuestionnaireFormContainerStyled sx={{ marginTop: '0 !important' }}>
        {sections.map((section) => {
          return (
            <>
              <h4 data-testid="application-survey-section">{section.Title}</h4>
              {questions.map((question, questionIndex) => {
                return (
                  <>
                    {question.ProductQuestions.StateApplicationQuestion.map(
                      (stateQuestion) => {
                        if (
                          stateQuestion.SectionID !== section.SectionID ||
                          isHiddenFollowUp(
                            questions,
                            responses,
                            stateQuestion,
                            questionIndex
                          )
                        ) {
                          return null;
                        }
                        return (
                          <>
                            <p
                              className="mb-0"
                              dangerouslySetInnerHTML={{
                                __html: stateQuestion.QuestionText,
                              }}
                            />
                            <SurveyResponseContainerStyled
                              $columnStyle={false}
                              $displayStyle="flex"
                              className="pb-3"
                              data-testid="unum-response-container"
                            >
                              <UnumDetailFieldStyled className="w-50">
                                {renderUnumApplicationQuestion(
                                  stateQuestion,
                                  handleChange
                                )}
                                {stateQuestion.QuestionAnswerDetails &&
                                  stateQuestion.QuestionAnswerDetails.QuestionAnswerDetail.map(
                                    (detail) => {
                                      return renderUnumQuestionDetails(
                                        detail,
                                        stateQuestion.QuestionID,
                                        responses,
                                        handleChange
                                      );
                                    }
                                  )}
                              </UnumDetailFieldStyled>
                            </SurveyResponseContainerStyled>
                          </>
                        );
                      }
                    )}
                  </>
                );
              })}
            </>
          );
        })}
      </QuestionnaireFormContainerStyled>
    </QuestionnaireContainerStyled>
  );
};
